/* eslint-disable no-shadow */
import React from 'react';

import styled, { css } from 'styled-components';

import { theme } from 'fpay-ui';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const Layout = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: transparent;
    width: 100%;
    border-radius: 6px;
    align-items: center;
    padding-top: 24px;
    padding-bottom: 62px;
  `
);

const ImageError = styled.img`
  width: ${(props) => props.widthSM};
  ${theme.breakpoint('md')} {
    width: ${(props) => props.widthMD};
  }
  ${theme.breakpoint('ll')} {
    width: ${(props) => props.widthLL};
    margin-top: 38px;
  }
`;

const ContainerText = styled.div`
  max-width: 550px;
  ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
  line-height: 1.25;
  color: #444b62;
  text-align: center;
  font-size: 14px;
  padding: 0 16px 0 16px;
  ${theme.breakpoint('md')} {
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 1.43;
    font-size: 14px;
    text-align: center;
  }
`;

const ContainerTextTitle = styled.div`
  width: 100%;
  padding: 0 16px 0 16px;
  ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
  line-height: 1.25;
  font-size: 18px;
  color: #444b62;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  margin-bottom: 16px;
  ${theme.breakpoint('md')} {
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    font-size: 24px;
    font-weight: 700;
    line-height: 1.43;
    text-align: center;
  }
`;

const Button = styled.div`
  ${theme.textTypes['Body-2-w400']}
  font-size: 14px;
  text-align: center;
  width: 100%;
  max-width: 173px;
  line-height: normal;
  color: ${theme.colors.white};
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: center;
  margin-top: 24px;
  border-radius: 6px;
  color: ${(props) => props.outlined && '#43B02A'};
  cursor: pointer;
  background-color: ${(props) => (props.outlined ? '#fff' : `${theme.colors.gbrand500}`)};
  border: ${(props) => props.outlined && '2px solid #43B02A'};
  transition: all 0.3s ease 0s;
  &:hover {
    box-shadow: 0 1px 6px rgb(32 33 36 / 28%);
    background-color: ${(props) => (props.outlined ? '' : `${theme.colors.gbrand600}`)};
  }
  &:active {
    border: 1px solid ${theme.colors.gbrand500};
  }
`;

const NoMovementsTransactions = ({
  text1,
  text2,
  title,
  image,
  textButton,
  onClickButton,
  withButton = false,
  widthLL,
  widthMD,
  widthSM,
  outlined,
  className,
}) => (
  <Layout {...{ className }}>
    <ImageError
      src={`${publicPath}/${image}`}
      alt="Ayuda"
      widthLL={widthLL}
      widthMD={widthMD}
      widthSM={widthSM}
    />
    <ContainerTextTitle>{title}</ContainerTextTitle>
    <ContainerText>{text1}</ContainerText>
    <ContainerText>{text2}</ContainerText>
    {withButton && (
      <Button onClick={onClickButton} outlined={outlined}>
        {textButton}
      </Button>
    )}
  </Layout>
);

export default NoMovementsTransactions;
